import {SubmissionError} from "redux-form";

import * as accountApi from '../services/api/account';
import * as sessionActions from '../actions/session';

export const REFRESH_ACCOUNT_RECEIVED = 'REFRESH_ACCOUNT_RECEIVED';
export const ACCOUNT_IS_LOADING = 'ACCOUNT_IS_LOADING';
export const SHOWING_AUTH_METHOD_SETUP = 'SHOWING_AUTH_METHOD_SETUP';
export const AUTH_SETUP_SUCCESS = 'AUTH_SETUP_SUCCESS';

export function saveAccount(values) {
    return dispatch => {
        return accountApi
            .saveAccount(values)
            .then(res => {

                dispatch(accountReceived(res.payload));

                if (res.payload.confirmed) {
                    dispatch(sessionActions.setSessionUser(res.payload));
                } else {
                    dispatch(sessionActions.changeRequiresConfirmation(true));
                    dispatch(sessionActions.setSessionUser(null));
                }

                return res.payload;
            })
            .catch((res) => {
                throw new SubmissionError({
                    ...res.payload,
                    _error: res.payload
                });
            });
    }
}

export function refreshAccount(userId) {
    return dispatch => {

        const success = (res) => {
            dispatch(accountReceived(res.payload));
            dispatch(accountLoading(false));
        }

        const failure = (errors) => {
            console.log(errors);
        }

        dispatch(accountLoading(true));

        return accountApi
            .getOne(userId)
            .then(success, failure);
    }
}

export function accountReceived(account) {
    return {
        type: REFRESH_ACCOUNT_RECEIVED,
        account
    }
}

export function accountLoading(isLoading) {
    return {
        type: ACCOUNT_IS_LOADING,
        isLoading
    }
}

export function toggleAuthMethodSetup(method) {
    return {
        type: SHOWING_AUTH_METHOD_SETUP,
        method
    }
}

export function authSetupSuccess(isSuccessful) {
    return {
        type: AUTH_SETUP_SUCCESS,
        isSuccessful
    }
}